import { render } from "./browseBlogs.vue?vue&type=template&id=243f5473&scoped=true"
import script from "./browseBlogs.vue?vue&type=script&lang=js"
export * from "./browseBlogs.vue?vue&type=script&lang=js"

import "./browseBlogs.vue?vue&type=style&index=0&id=243f5473&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-243f5473"]])

export default __exports__